import { Component, OnDestroy, OnInit } from "@angular/core";
import { formatMessage } from "devextreme/localization";
import { P3AuthService, ScreenService } from "../../shared/services";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { NewsService } from "../../shared/services/news.service";
import { Subscription } from "rxjs";
import DevExpress from "devextreme";
import ToastType = DevExpress.ui.dxToast.ToastType;

@Component({
  templateUrl: "home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
  formatMessage = formatMessage;

  isXSmall: boolean;
  isSmall: boolean;

  loading: boolean = true;

  toastType = "success" as ToastType;
  toastMessage: string = "For some reason we need an initial value here...";
  showToast: boolean = false;

  greeting: string;
  userRole: string;

  info: string = "";

  lastNewsletterIds: string[] = [];

  isAllowedToCreateNewsElementSubscription: Subscription;
  isAllowedToCreateNewsElement: boolean;
  popupVisible: boolean = false;

  showConfirmationPopup: boolean = false;
  newsIdToDelete: string;

  constructor(
    private http: HttpClient,
    private authService: P3AuthService,
    private screenService: ScreenService,
    private _p3AuthService: P3AuthService,
    private newsService: NewsService,
  ) {
    this.translateTimeWindow = this.translateTimeWindow.bind(this);
  }

  ngOnInit(): void {
    this.isXSmall = this.screenService.sizes["screen-x-small"];
    this.isSmall = this.screenService.sizes["screen-small"];

    this.isAllowedToCreateNewsElementSubscription = this._p3AuthService
      .isAllowedToCreateNewsElement()
      .subscribe((data) => {
        this.isAllowedToCreateNewsElement = data;
      });

    this.loadUserAndData();

    this.loadLastNewsletters();
  }

  ngOnDestroy(): void {
    this.isAllowedToCreateNewsElementSubscription?.unsubscribe();
  }

  translateTimeWindow(timeWindow: string): string {
    return formatMessage("timeWindow.upper." + timeWindow);
  }

  private loadLastNewsletters(): void {
    this.newsService.loadLastNewsletters().then((data) => {
      this.lastNewsletterIds = data;
    });
  }

  private loadUserAndData(): void {
    this.authService
      .getUser()
      .toPromise()
      .then((user) => {
        this.calculateGreetings(
          user?.identity?.firstName,
          user?.identity?.lastName
        );

        this.userRole = user?.role ? user.role : "";

        this.http
          .get<any>(environment.baseUrl + "/actuator/info")
          .toPromise()
          .then((data) => {
            this.info = JSON.stringify(data);
            this.loading = false;
          });
      })
      .catch(() => {
        this.toastType = "error";
        this.toastMessage = formatMessage("home.error");
        this.showToast = true;

        this.loading = false;
      });
  }

  private calculateGreetings(
    firstName: string | undefined = undefined,
    lastName: string | undefined = undefined
  ): void {
    const now = new Date();

    const isMorning =
      now.getHours() < 11 || (now.getHours() === 11 && now.getMinutes() <= 30);

    const isEvening = now.getHours() >= 18;

    const greetingPrefix = isMorning
      ? formatMessage("home.greeting.morning")
      : isEvening
      ? formatMessage("home.greeting.evening")
      : formatMessage("home.greeting");

    const name = firstName
      ? ", " + firstName + (lastName ? " " + lastName : "")
      : lastName
      ? ", " + lastName
      : "";

    this.greeting = greetingPrefix + name + "!";
  }

  handleNewsElementOnSave(): void {
    this.toastType = "success";
    this.toastMessage = formatMessage("news.create.success");
    this.showToast = true;

    this.loadLastNewsletters();
  }

  handleNewsElementOnError(): void {
    this.toastType = "error";
    this.toastMessage = formatMessage("news.create.error");
    this.showToast = true;
  }

  handleOnDelete(newsId: string) {
    this.newsIdToDelete = newsId;
    this.showConfirmationPopup = true;
  }

  executeDeleteOperation() {
    this.newsService
      .deleteNewsletter(this.newsIdToDelete)
      .then((_) => {
        this.toastType = "success";
        this.toastMessage = formatMessage("news.delete.success");
        this.showToast = true;

        this.loadLastNewsletters();
      })
      .catch((e) => {
        this.toastType = "error";
        this.toastMessage = formatMessage("news.delete.error");
        this.showToast = true;
      })
      .finally(() => {
        this.showConfirmationPopup = false;
      });
  }
}
